/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ api: NonNullable<unknown> }} External_Apis_Space_Add_TitleInputs */



/**
* | output |
* | --- |
* | "New space for {api}" |
*
* @param {External_Apis_Space_Add_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_add_title = /** @type {((inputs: External_Apis_Space_Add_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Add_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Neuer Space für ${i?.api}`)
	return /** @type {LocalizedString} */ (`New space for ${i?.api}`)
});